import { ref as a, nextTick as u, onUpdated as d, unref as g } from "vue";
import { tryOnMounted as y } from "../node_modules/.pnpm/@vueuse_shared@13.1.0_vue@3.5.13_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
import { findFirstChildVNode as m } from "../util.js";
import { provideChildrenTracker as D, useChildrenTracker as H } from "./children-tracker.js";
import { useFloatingUI as b } from "./floating.js";
function h(o) {
  let t = o == null ? void 0 : o.el;
  if (t instanceof Node && (t instanceof Element || (t = t.nextElementSibling), t instanceof Element))
    return t;
}
function k(o) {
  const t = a();
  return {
    element: t,
    async findReference(l) {
      const i = m(l, o);
      (i == null ? void 0 : i.component) === null && await u(), t.value = h(i);
    }
  };
}
function v(o) {
  const t = a();
  return {
    element: t,
    async findComponentVNode(l) {
      const i = m(l, o);
      (i == null ? void 0 : i.component) === null && await u(), t.value = i;
    }
  };
}
function E(o) {
  const t = () => {
    const e = g(o);
    return e.length && Array.isArray(e[0]) ? e.map((r) => r.filter((n) => !n.disabled)) : e.filter((r) => !r.disabled);
  }, l = (e, f, s) => {
    const r = t();
    if (!Array.isArray(r) || !r.length)
      return;
    let n = e, c = f;
    if (s === "up" ? e <= 0 ? n = r.length - 1 : n = e - 1 : s === "down" ? e >= r.length - 1 ? n = 0 : n = e + 1 : s === "left" ? f <= 0 ? c = r[e].length - 1 : c = f - 1 : s === "right" && (f >= r[e].length - 1 ? c = 0 : c = f + 1), !r[n] || Array.isArray(r[n]) && !r[n][c]) {
      l(n, c, s);
      return;
    }
    Array.isArray(r[n]) ? r[n][c].focused = !0 : r[n].focused = !0;
  }, i = function(e, f) {
    f || (f = this.focusElement());
    const s = f === e.currentTarget ? 0 : 1, n = t().findIndex((c) => !Array.isArray(c) && c.focused);
    if (e.key === "ArrowUp")
      l(n, s, "up");
    else if (e.key === "ArrowDown")
      l(n, s, "down");
    else if (e.key === "ArrowRight")
      l(n, s, "right");
    else if (e.key === "ArrowLeft")
      l(n, s, "left");
    else if (e.key === "Enter" || e.key === " ")
      e.currentTarget instanceof HTMLElement && e.currentTarget.click(), this.enterTriggersArrowDown && l(n, s, "down");
    else
      return;
    e.preventDefault();
  };
  return i.navigate = l, i;
}
function T(o) {
  const t = a(!1), l = () => {
    var i, e;
    if (!window || !o.value) {
      t.value = !1;
      return;
    }
    t.value = o.value.scrollWidth > o.value.clientWidth || ((i = o.value) == null ? void 0 : i.scrollHeight) > ((e = o.value) == null ? void 0 : e.clientHeight);
  };
  return y(l), d(l), t;
}
export {
  h as findHtmlElementFromVNode,
  E as keyNavigation,
  D as provideChildrenTracker,
  H as useChildrenTracker,
  v as useComponentVNode,
  T as useElementOverflow,
  b as useFloatingUI,
  k as useHtmlElementFromVNodes
};
